import { type TemplateType } from '~/types/template';

export const templateType = {
  DYNAMIC_PAGE: 'DYNAMIC_PAGE',
  LANDING_PAGE: 'LANDING_PAGE',
  SPORTS_PAGE_GRID: 'SPORTS_PAGE_GRID',
  SPORTS_PAGE_HUB: 'SPORTS_PAGE_HUB',
} as const satisfies Record<TemplateType, TemplateType>;
